<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" :class="size">
                    <div class="modal-header" v-if="$slots.header">
                        <slot name="header"></slot>
                        <w-close-icon id="close-modal" @click="close"></w-close-icon>
                    </div>
                    <div class="modal-body">
                        <w-close-icon class="mobile-close" @click="close"></w-close-icon>
                        <slot name="body"></slot>
                    </div>
                    <div class="modal-footer" v-if="$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'WModal',
    props: ['size'],
    methods: {
        close () {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        /*width: 800px;*/
        margin: 0 auto;
        /*padding: 20px 30px;*/
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        /*font-family: Helvetica, Arial, sans-serif;*/
    }

    .modal-container.xs {
        width: 300px;
    }

    .modal-container.lg {
        width: 1120px;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .mobile-close {
        display: none;
    }

    @media (max-width: 1120px) {
        .modal-container {
            width: 90% !important;
        }
    }

    /*@media (min-width: 768px) {*/
    /*.modal-container{*/
    /*width: 800px;*/
    /*}*/
    /*}*/
    @media (max-width: 768px) {
        .modal-header, .modal-footer {
            display: none;
        }

        .modal-body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
        }

        .modal-wrapper,
        .modal-body {
            height: 100%;
            width: 100%;
            display: table;
            transition: opacity .3s ease;
        }

        .modal-container.lg {
            height: inherit;
            background-color: rgba(0, 0, 0, 0);
            width: 100% !important;
        }

        .mobile-close {
            display: block;
            z-index: 10000;
            right: 15px;
            position: absolute;
            top: 15px;
        }

        .modal-mask {
            background-color: rgba(0, 0, 0, .9);
        }
    }

    /*
     *
     * Animations
     *
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
